
import React from 'react';
import './App.css';
import Signature from './Signature';
import TextField from '@material-ui/core/TextField';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import GridContainer from "./components/Grid/GridContainer";
import GridItem from "./components/Grid/GridItem";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText, Paper } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import moment from "moment";
import Typography from '@material-ui/core/Typography';
// import { PDFDownloadLink, Document, Page,PDFViewer } from '@react-pdf/renderer'
import axios from "axios";
import Qs from "qs";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import { actions } from "./reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "./_Services/publicFunction";
import LinearProgress from '@material-ui/core/LinearProgress';
import useSound from 'use-sound';
import clickdown from './sounds/clickdown.wav';
import clickup from './sounds/clickdown.wav';

// var domToPdf = require('dom-to-pdf');
// const domToImage = require('dom-to-image');

// var instance = axios.create({
//   // timeout: 1000,   //暫不設置timeout
//   async: true,
//   crossDomain: true,
//   headers: {
//     "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
//     "X-Requested-With": "XMLHttpRequest", //for MVC Request.IsAjaxRequest()
//   }
// });

const ref = React.createRef();
const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 8,
    // borderRadius: 5,
  },
  colorPrimary: {
    //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    // borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);
function App(props) {
  const { tabList } = useSelector(state => ({
    tabList: state.app.tabList,
  }));
  const [numerator, setNumerator] = React.useState(0);
  const [denominator, setDenominator] = React.useState(15);
  React.useEffect(() => {
    console.log("分子", numerator);
  }, [numerator])
  React.useEffect(() => {
    console.log("分母", denominator);
  }, [denominator])


  const dispatch = useDispatch();

  const { handleNext, setActiveStep } = props;

  const initialRender = React.useRef(true);
  const [imageURL, setImage] = React.useState(null);  //提交=>簽名檔img
  // const [open, setOpen] = React.useState(false);
  const [playActive] = useSound(
    clickdown,
    { volume: 0.25 }
  );
  const [playOn] = useSound(
    clickup,
    { volume: 0.25 }
  );
  const [uploadFormat, setUpload] = React.useState({
    0: { BarCodeStr: "", QuestionNo: 66, Category: "作業經歷", titleNo: 1, Title: "", SelectTitle: "曾經從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月", Answer: "", Other: "" },
    1: { BarCodeStr: "", QuestionNo: 66, Category: "作業經歷", titleNo: 2, Title: "", SelectTitle: "目前從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月", Answer: "", Other: "" },
    2: { BarCodeStr: "", QuestionNo: 66, Category: "作業經歷", titleNo: 3, Title: "", SelectTitle: "過去1個月，平均每週工時為：＿小時；過去6個月，平均每週工時為：＿小時", Answer: "", Other: "" },
    3: { BarCodeStr: "", QuestionNo: 66, Category: "作業檢查時期", titleNo: 1, Title: "檢查時期（原因）", SelectTitle: "□新進員工（受僱時）　□定期檢查", Answer: "", Other: "" },
    4: { BarCodeStr: "", QuestionNo: 66, Category: "既往病史", titleNo: 1, Title: "您是否曾患有下列慢性疾病：（請在適當項目前打勾）", SelectTitle: "□高血壓　□糖尿病　□心臟病　□癌症＿　□白內障　□中風　□癲癇　□氣喘　□慢性氣管炎、肺氣腫　□肺結核　□腎臟病　□肝病　□貧血　□中耳炎　□聽力障礙　□甲狀腺疾病　□消化性潰瘍、胃炎　□逆流性食道炎 □骨折＿　□手術開刀＿　□其他慢性病＿ □以上皆無", Answer: "", Other: "" },
    5: { BarCodeStr: "", QuestionNo: 66, Category: "生活習慣", titleNo: 1, Title: "請問您過去一個月內是否有吸菸？", SelectTitle: "□從未吸菸　□偶爾吸(不是天天)　□（幾乎）每天吸，平均每天吸＿支，已吸菸＿年　□已經戒菸，戒了＿年＿個月。", Answer: "", Other: "" },
    6: { BarCodeStr: "", QuestionNo: 66, Category: "生活習慣", titleNo: 2, Title: "請問您最近六個月內是否有嚼食檳榔？", SelectTitle: "□從未嚼食檳榔　□偶爾嚼(不是天天)　□(幾乎)每天嚼，平均每天嚼＿顆，已嚼＿年　□已經戒食，戒了＿年＿個月。", Answer: "", Other: "" },
    7: { BarCodeStr: "", QuestionNo: 66, Category: "生活習慣", titleNo: 3, Title: "請問您過去一個月內是否有喝酒？", SelectTitle: "□從未喝酒　□偶爾喝(不是天天)　□（幾乎）每天喝，平均每週喝＿次，最常喝＿酒，每次＿瓶　□已經戒酒，戒了＿年＿個月。", Answer: "", Other: "" },
    8: { BarCodeStr: "", QuestionNo: 66, Category: "生活習慣", titleNo: 4, Title: "請問您於工作日期間", SelectTitle: "平均每天睡眠時間為：＿小時。", Answer: "", Other: "" },
    9: { BarCodeStr: "", QuestionNo: 66, Category: "自覺症狀", titleNo: 1, Title: "您最近三個月是否常有下列症狀：（請在適當項目前打勾）", SelectTitle: "□咳嗽□咳痰□呼吸困難□胸痛□心悸□頭暈□頭痛　□耳鳴　□倦怠　□噁心　□腹痛　□便秘　□腹瀉　□血便　□上背痛　□下背痛　□手腳麻痛　□關節疼痛　□排尿不適　□多尿、頻尿　□手腳肌肉無力　□體重減輕3公斤以上 □其他症狀＿ □以上皆無", Answer: "", Other: "" },
    10: { BarCodeStr: "", QuestionNo: 66, Category: "填表說明", titleNo: 1, Title: "請受檢員工於勞工健檢前，填妥基本資料、作業經歷、檢查時期、既往病史、生活習慣及自覺症狀六大項，再交由醫護人員作確認，以有效篩檢出疾病；若事業單位已提供受檢員工基本資料及作業經歷電子檔給指定醫療機構，可不必請受檢員工重複填寫。", SelectTitle: "目前從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月", Answer: "", Other: "" },
    11: { BarCodeStr: "", QuestionNo: 66, Category: "填表說明", titleNo: 2, Title: "自覺症狀乙項，請受檢者依自身實際症狀勾選。", SelectTitle: "目前從事＿，起始日期：＿年＿月，截止日期：＿年＿月，共＿年＿月", Answer: "", Other: "" },
  });
  // const dispatch = useDispatch();
  const { UserInfo } = useSelector(state => ({
    UserInfo: state.app.UserInfo,
  }));
  const Update66th = () => {
    //section 2 到3
    let y = moment(workExp.usedStart.value + '01日', 'YYYY年MM月DD日')
    let z = moment(workExp.usedEnd.value + '01日', 'YYYY年MM月DD日')
    let M = moment(workExp.rightNowStart.value + '01日', 'YYYY年MM月DD日')
    let N = moment(workExp.rightNowEnd.value + '01日', 'YYYY年MM月DD日')


    setUpload(prevState => ({
      ...prevState,
      0: { ...prevState[0], BarCodeStr: UserInfo.BarCodeStr, Other: workExp.usedJob.value + "||" + (y.year() - 1911) + "||" + (y.month() + 1) + "||" + (z.year() - 1911) + "||" + (z.month() + 1) + "||" + workExp.usedPeriod_Y.value + "||" + workExp.usedPeriod_M.value },
      1: { ...prevState[1], BarCodeStr: UserInfo.BarCodeStr, Other: workExp.rightNowJob.value + "||" + (M.year() - 1911) + "||" + (M.month() + 1) + "||" + (N.year() - 1911) + "||" + (N.month() + 1) + "||" + workExp.rightNowPeriod_Y.value + "||" + workExp.rightNowPeriod_M.value },
      2: { ...prevState[2], BarCodeStr: UserInfo.BarCodeStr, Other: workExp.workhours_1.value + "||" + workExp.workhours_2.value },
      3: { ...prevState[3], BarCodeStr: UserInfo.BarCodeStr, Answer: checked3rd.checkA ? "新進員工（受僱時）　" : "定期檢查" },
      4: { ...prevState[4], BarCodeStr: UserInfo.BarCodeStr, Answer: fourth.substring(2, 999), Other: fourthTxt.substring(2, 999) },
      5: { ...prevState[5], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_1.substring(2, 999), Other: fiveth_1Txt.substring(2, 999) },
      6: { ...prevState[6], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_2.substring(2, 999), Other: fiveth_2Txt.substring(2, 999) },
      7: { ...prevState[7], BarCodeStr: UserInfo.BarCodeStr, Answer: fiveth_3.substring(2, 999), Other: fiveth_3Txt.substring(2, 999) },
      8: { ...prevState[8], BarCodeStr: UserInfo.BarCodeStr, Other: array5thCheck.sleep.value },
      9: { ...prevState[9], BarCodeStr: UserInfo.BarCodeStr, Answer: Sixth.substring(2, 999), Other: array4thTxtObj.W6.text },
      10: { ...prevState[10], BarCodeStr: UserInfo.BarCodeStr },
      11: { ...prevState[11], BarCodeStr: UserInfo.BarCodeStr, },
    }));
    //console.log(uploadFormat);
    //section 4
    let fourth = Object.values(array4th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fourthTxt = Object.values(array4thTxtObj).reduce((a, b) => a + ("||" + b.text), "");
    //section 5
    let fiveth_1 = Object.values(array5_1).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_1Txt = Object.values(array5thCheck).slice(1, 5).reduce((a, b) => a + "||" + b.value, "")
    let fiveth_2 = Object.values(array5_2).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_2Txt = Object.values(array5thCheck).slice(6, 10).reduce((a, b) => a + "||" + b.value, "")
    let fiveth_3 = Object.values(array5_3).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    let fiveth_3Txt = Object.values(array5thCheck).slice(11, 16).reduce((a, b) => a + "||" + b.value, "")
    //setction 6
    let Sixth = Object.values(array6th).reduce((a, b) => a + (b.checked ? "||" + b.systemLabel : ""), "");
    //列印
    // })
    //   var doc = new jsPDF();
    //   //return pdf; //Duke
    // //var doc = new jsPDF(pdf2);
    // //console.log(pdf);
    // //pdf.name = 'test.pdf'

    //var pdf = pdf2.output('blob');
    //pdf.name = 'test.pdf'
    //console.log(pdf);
    // var doc = pdf.output('blob')
    // let data = new FormData();
    // data.append('files', imageURL.getCanvas());
    // //console.log(data);
    // //var doc = btoa(pdf);
    // instance({
    //   method: "post",
    //   url: 'https://localhost:44311' + "/Questionaire/Upload",
    //   data: data,
    // })
    //   .then(function (response) {
    //     console.log(response.data)
    //   })
  }

  React.useEffect(() => {
    if (!initialRender.current) {

      PF.instance({
        method: "post",
        url: PF.url + "/Questionaire/Insert",
        data: Qs.stringify({ list: Object.values(uploadFormat) }),
        headers: { token: sessionStorage.token }
      })
        .then(function (response) {
          // console.log(response.data)
          const { TotalRecord, ErrorMessage } = response.data
          if (TotalRecord <= 0) {
            alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")

          } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setImage("Image");
          }
        })

    }
  }, [uploadFormat]); //避免循環

  // React.useEffect(() => {
  //   if (initialRender.current) {
  //     initialRender.current = false;
  //   } else {

  //     var element = document.getElementById('signature');
  //     var options = {
  //       filename: uploadFormat[0].BarCodeStr + '.pdf',
  //     };
  //     // var pdf = new jsPDF();

  //     domToImage.toBlob(element).then((blob) => {
  //       // var image = canvas.toDataURL("image/png");
  //       // pdf.addImage(image, 'JPEG', 0, 0);
  //       // document.body.appendChild(image)
  //       // var pdf2 = pdf.output('blob');
  //       let data = new FormData();
  //       data.append('files', blob, uploadFormat[0].BarCodeStr + "-" + new Date().toISOString().split('T')[0] + '.png')
  //       PF.instance({
  //         method: "post",
  //         url: PF.url + "/Questionaire/Upload",
  //         data: data,
  //         headers: { token: sessionStorage.token }
  //       })
  //         .then(function (response) {
  //           // alert("完成")
  //           //console.log(response.data)
  //         })

  //     })
  //   }
  // }, [imageURL]); //避免循環


  const handleChange = e => {
    if (!_.isNil(imageURL)) {//已提交不得修改

    }
  }
  const [recordObj, setObj] = React.useState({
    name: "",
    id: ""
  });


  const [array4th, setArray4th] = React.useState({
    A4: { name: "A4", label: "高血壓", type: "chkBox", checked: false, gridWid: 3, systemLabel: "高血壓　" }
    , B4: { label: "糖尿病", name: "B4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "糖尿病　" }
    , C4: { label: "心臟病", name: "C4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心臟病　" }
    , E4: { label: "白內障", name: "E4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "白內障　" }
    , F4: { label: "中風", name: "F4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中風　" }
    , G4: { label: "癲癇", name: "G4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "癲癇　" }
    , H4: { label: "氣喘", name: "H4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "氣喘　" }
    , I4: { label: "慢性氣管炎、肺氣腫", name: "I4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "慢性氣管炎、肺氣腫　" }
    // , J4: { label: "肺氣腫", name: "J4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺氣腫　" }
    , K4: { label: "肺結核", name: "K4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肺結核　" }
    , L4: { label: "腎臟病", name: "L4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腎臟病　" }
    , M4: { label: "肝病", name: "M4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "肝病　" }
    , N4: { label: "貧血", name: "N4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "貧血　" }
    , O4: { label: "中耳炎", name: "O4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "中耳炎　" }
    , P4: { label: "聽力障礙", name: "P4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "聽力障礙　" }
    , Q4: { label: "甲狀腺疾病", name: "Q4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "甲狀腺疾病　" }
    , R4: { label: "消化性潰瘍、胃炎", name: "R4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "消化性潰瘍、胃炎　" }
    , S4: { label: "逆流性食道炎", name: "S4", type: "chkBox", checked: false, gridWid: 3, systemLabel: "逆流性食道炎" }
    , D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "癌症" }
    , T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "骨折" }
    , V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, systemLabel: "手術開刀" }
    , U4: { label: "其他慢性病", name: "U4", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "其他慢性病" }
    , allNone: { label: "以上皆無", name: "allNone", type: "chkBox", checked: false, gridWid: 3, systemLabel: "以上皆無" }
  });

  const [array4thTxtObj, set4thTxtObj] = React.useState({
    D4: { label: "癌症", name: "D4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    // N4: { label: "貧血", name: "N4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    T4: { label: "骨折", name: "T4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    V4: { label: "手術開刀", name: "V4", type: "chkBoxTxT", checked: false, gridWid: 6, text: "" },
    U4: { label: "其他慢性病", name: "U4", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
    W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, text: "" },
  })

  const handleChange4th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(e.target);
      if (name === "allNone") {
        if (array4th.allNone.checked === false) {
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array4th, function (value, key) {
            setArray4th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array4thTxtObj, function (value, key) {
            if (key !== "W6") {
              set4thTxtObj(prevState => ({
                ...prevState,
                [key]: { ...value, text: "" }
              }));
            }

          });

          //自己勾上
          setArray4th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        } else {
          //自己取消，讓其他可以勾
          setArray4th(prevState => ({
            ...prevState,
            allNone: { ...prevState[name], checked: checked }
          }));
        }


      } else {
        //其他:不能勾選，除非allnone不勾
        if (array4th.allNone.checked === false) {
          setArray4th(prevState => ({
            ...prevState,
            [name]: {
              ...array4th[name], checked: checked,
              error: checked === false ? false : (prevState[name].error || false)
            }
          }))
          if (Object.keys(array4thTxtObj).includes(name)) {
            if (name !== "W6") {
              set4thTxtObj(prevState => ({
                ...prevState,
                [name]: {
                  ...prevState[name],
                  checked: checked,  //也要更新 for資料庫導入格式
                  text: checked === false ? "" : (prevState[name].text || "")
                }
              }))
            }

          }
        }
      }
    }
  }
  const handleChangeTxt4th = e => {  //第四區塊文字，抽取出來，改動文字不去觸發calculate_4th
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      set4thTxtObj({
        ...array4thTxtObj,
        [name]: { ...array4thTxtObj[name], text: value }
      })
    }
  }
  const [array4thValidator, set4thValidator] = React.useState({
    pastHistory: { name: "pastHistory", checked: false },
    conscious: { name: "conscious", checked: false }
  })


  const calculate_4th = () => {
    const total = Object.values(array4th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)

    set4thValidator(prevState => ({
      ...prevState,
      pastHistory: { ...prevState.pastHistory, checked: total >= 1 ? true : false }
    }));
    if (total >= 1 && !array4thValidator.pastHistory.checked) {
      setNumerator(prev => prev + 1)
    } else if (total === 0 && array4thValidator.pastHistory.checked) {
      setNumerator(prev => prev - 1)
    }
  }
  React.useEffect(() => {
    if (!initialRender.current) {
      calculate_4th();
    }
  }, [array4th]); //避免循環

  const [array6th, setArray6th] = React.useState({
    A6: { label: "咳嗽", name: "A6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "咳嗽" }
    , B6: { label: "咳痰", name: "B6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "咳痰" }
    , C6: { label: "呼吸困難", name: "C6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "呼吸困難" }
    , E6: { label: "胸痛", name: "E6", type: "chkBox", gridWid: 3, systemLabel: "胸痛" }
    , F6: { label: "心悸", name: "F6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "心悸" }
    , G6: { label: "頭暈", name: "G6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "頭暈" }
    , H6: { label: "頭痛", name: "H6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "頭痛　" }
    , I6: { label: "耳鳴", name: "I6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "耳鳴　" }
    , J6: { label: "倦怠", name: "J6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "倦怠　" }
    , K6: { label: "噁心", name: "K6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "噁心　" }
    , L6: { label: "腹痛", name: "L6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腹痛　" }
    , M6: { label: "便秘", name: "M6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "便秘　" }
    , O6: { label: "腹瀉", name: "O6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "腹瀉　" }
    , P6: { label: "血便", name: "P6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "血便　" }
    , Q6: { label: "上背痛", name: "Q6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "上背痛　" }
    , R6: { label: "下背痛", name: "R6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "下背痛　" }
    , S6: { label: "手腳麻痛", name: "S6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "手腳麻痛　" }
    , D6: { label: "關節疼痛", name: "D6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "關節疼痛　" }
    , N6: { label: "排尿不適", name: "N6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "排尿不適　" }
    , T6: { label: "多尿、頻尿", name: "T6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "多尿、頻尿　" }
    , V6: { label: "手腳肌肉無力", name: "V6", type: "chkBox", checked: false, gridWid: 3, systemLabel: "手腳肌肉無力　" }
    , U6: { label: "體重減輕 3公斤以上", name: "U6", type: "chkBox", checked: false, checked: false, gridWid: 6, systemLabel: "體重減輕3公斤以上" }
    , W6: { label: "其他症狀", name: "W6", type: "chkBoxTxT", checked: false, checked: false, gridWid: 6, systemLabel: "其他症狀" }
    , allNone6: { label: "以上皆無", name: "allNone6", type: "chkBox", checked: false, gridWid: 12, systemLabel: "以上皆無" }
  });


  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array6th).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      set4thValidator(prevState => ({
        ...prevState,
        conscious: { ...prevState.conscious, checked: total >= 1 ? true : false }
      }));

      if (total >= 1 && !array4thValidator.conscious.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0 && array4thValidator.conscious.checked) {
        setNumerator(prev => prev - 1)
      }
    }

  }, [array6th]); //避免循環

  const handleChange6th = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      // console.log(name, checked);
      if (name === "allNone6") {
        if (checked === true) {  //之前沒溝
          // console.log("allNon6自己溝上");
          //其他: 不能勾選，除非allnone不勾
          //移除所以勾勾  
          _.forEach(array6th, function (value, key) {
            setArray6th(prevState => ({
              ...prevState,
              [key]: omit(value, ["checked", "error"]),
            }));
          });
          //移除所有文字
          _.forEach(array4thTxtObj, function (value, key) {
            set4thTxtObj(prevState => ({
              ...prevState,
              W6: { ...value, text: "" }
            }));
          });

          //自己勾上
          setArray6th(prevState => ({
            ...prevState,
            allNone6: { ...prevState[name], checked: checked }
          }));
        } else {
          // console.log("allNon6自己取消");

          //自己取消，讓其他可以勾
          setArray6th(prevState => ({
            ...prevState,
            [name]: { ...prevState[name], checked: false }
          }));
        }


      } else {
        //其他:不能勾選，除非allnone不勾
        if (array6th.allNone6.checked === false) {
          setArray6th(prevState => ({
            ...prevState,
            [name]: {
              ...prevState[name], checked: checked,
              error: checked === false ? false : (prevState[name].error || false)
            }
          }))
          if (Object.keys(array4thTxtObj).includes(name)) {
            set4thTxtObj(prevState => ({
              ...prevState,
              [name]: {
                ...prevState[name],
                text: checked === false ? "" : (prevState[name].text || "")
              }
            }))
          }
        }
      }
    }
  }

  const [checked3rd, setCheck3rd] = React.useState({
    checkA: null,
    checkB: null,
    error: false
  });
  const handleChangeThree = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      if (name === "checkA") {
        setCheck3rd(prevState => ({
          ...prevState,
          checkB: !checked,
          checkA: checked
        }))
        if (checked3rd.checkA === null) {
          setNumerator(prev => prev + 1);
        }
        if (checked) {
          //取消曾經
          setWorkExp(prevState => ({
            ...prevState,
            usedJob: { ...prevState.usedJob, required: false },
            usedStart: { ...prevState.usedStart, required: false },
            usedEnd: { ...prevState.usedEnd, required: false }
          }))
          setDenominator(12);
          //之前填過，若有數值，需-1
          let ary = ["usedJob", "usedStart", "usedEnd"];
          ary.map(item => {
            if (workExp[item].value !== "" && workExp[item].value !== null) {
              setNumerator(prev => prev - 1)
            }
          })

        } else {
          setWorkExp(prevState => ({
            ...prevState,
            usedJob: { ...prevState.usedJob, required: true },
            usedStart: { ...prevState.usedStart, required: true },
            usedEnd: { ...prevState.usedEnd, required: true }
          }))
          //之前填過，若有數值，需+1
          setDenominator(15);
          let ary = ["usedJob", "usedStart", "usedEnd"];
          ary.map(item => {
            if (workExp[item].value !== "" && workExp[item].value !== null && workExp[item].required !== true) {
              setNumerator(prev => prev + 1)
            }
          })
        }
      } else {  //checkB定期檢查
        setCheck3rd(prevState => ({
          ...prevState,
          checkB: checked,
          checkA: !checked
        }))
        if (checked3rd.checkB === null) {
          setNumerator(prev => prev + 1);
        }
        if (checked) {
          //取消曾經
          setWorkExp(prevState => ({
            ...prevState,
            usedJob: { ...prevState.usedJob, required: true },
            usedStart: { ...prevState.usedStart, required: true },
            usedEnd: { ...prevState.usedEnd, required: true }
          }))
          setDenominator(15);
          let ary = ["usedJob", "usedStart", "usedEnd"];
          ary.map(item => {
            if (workExp[item].value !== "" && workExp[item].value !== null && workExp[item].required !== true) {
              setNumerator(prev => prev + 1)
            }
          })
        } else {
          setWorkExp(prevState => ({
            ...prevState,
            usedJob: { ...prevState.usedJob, required: false },
            usedStart: { ...prevState.usedStart, required: false },
            usedEnd: { ...prevState.usedEnd, required: false }
          }))
          setDenominator(12);
          let ary = ["usedJob", "usedStart", "usedEnd"];
          ary.map(item => {
            if (workExp[item].value !== "" && workExp[item].value !== null) {
              setNumerator(prev => prev - 1)
            }
          })
        }

      }
    }
  }


  const [array5_1, setArray5_1] = React.useState({
    smokeA: { name: "smokeA", label: "從未吸菸", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未吸菸　" }
    , smokeB: { name: "smokeB", label: "偶爾吸(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾吸(不是天天)　" }
    , smokeC: {
      systemLabel: "（幾乎）每天吸，平均每天吸＿支，已吸菸＿年",
      label: "(幾乎)每天吸", name: "smokeC", type: "chkBoxTxT", checked: false, gridWid: 8
      , type_1: "number", name_1: "smokeC_1", label_1: "平均每天吸", text_1: "", suffix1: "支", helperText_1: "", min_1: 1
      , type_2: "number", name_2: "smokeC_2", label_2: "已吸菸", text_2: "", suffix2: "年", helperText_2: "", max_2: 100
    }
    , smokeD: {
      systemLabel: "已經戒菸，戒了＿年＿個月。",
      label: "已經戒菸，戒了", name: "smokeD", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "smokeD_1", type_1: "number", label_1: " ", text_1: "", suffix1: "年", helperText_1: "", max_1: 100
      , name_2: "smokeD_2", type_2: "number", label_2: " ", text_2: "", suffix2: "個月", helperText_2: "", max_2: 12 //label需有空格
    }
  });
  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_1).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        smoke: { ...prevState.smoke, checked: total >= 1 ? true : false } //只更新這個
      }));
      if (total >= 1 && !array5thCheck.smoke.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_1]); //避免循環

  const handleChangeChk5_1 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_1);
      keys.map(item => {
        // console.log(item)
        delete array5_1[item].checked
      })
      //set
      setArray5_1({
        ...array5_1,
        [name]: { ...array5_1[name], checked: checked }
      });
      setArray5thCheck(prevState => ({
        ...prevState,
        smokeC_1: { ...prevState.smokeC_1, value: "", error: false },
        smokeC_2: { ...prevState.smokeC_2, value: "", error: false },
        smokeD_1: { ...prevState.smokeD_1, value: "", error: false },
        smokeD_2: { ...prevState.smokeD_2, value: "", error: false },
      }));

    }
  }
  const [array5thCheck, setArray5thCheck] = React.useState({
    smoke: { name: "smoke", checked: false },
    smokeC_1: { name: "smokeC_1", value: "" },
    smokeC_2: { name: "smokeC_2", value: "" },
    smokeD_1: { name: "smokeD_1", value: "" },
    smokeD_2: { name: "smokeD_2", value: "" },
    betel: { name: "betel", checked: false },
    betelC_1: { name: "betelC_1", value: "" },
    betelC_2: { name: "betelC_2", value: "" },
    betelD_1: { name: "betelD_1", value: "" },
    betelD_2: { name: "betelD_2", value: "" },
    drunk: { name: "drunk", checked: false },
    drunkC_1: { name: "drunkC_1", value: "" },
    drunkC_2: { name: "drunkC_2", value: "" },
    drunkC_3: { name: "drunkC_3", value: "" },
    drunkD_1: { name: "drunkD_1", value: "" },
    drunkD_2: { name: "drunkD_2", value: "" },
    sleep: { name: "sleep", checked: false, value: "" },

  });
  const handleChangeTxt5_4 = e => { //目前只5-4使用
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setArray5thCheck(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }));
      if (array5thCheck.sleep.value === "" && value !== "") {
        setNumerator(prev => prev + 1)
      } else if (value === "") {
        setNumerator(prev => prev - 1)
      }
      // console.log(array5thCheck)
    }
  }

  const handleChangeTxt5_1 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setArray5thCheck(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }));
    }
  }



  const [array5_2, setArray5_2] = React.useState({
    betelA: { name: "betelA", label: "從未嚼食檳榔", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未嚼食檳榔　" }
    , betelB: { name: "betelB", label: "偶爾嚼(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾嚼(不是天天)　" }
    , betelC: {
      systemLabel: "(幾乎)每天嚼，平均每天嚼＿顆，已嚼＿年",
      label: "(幾乎)每天嚼", name: "betelC", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "betelC_1", type_1: "number", label_1: "平均每天嚼", text_1: "", suffix1: "顆", helperText_1: "", max_1: 100
      , name_2: "betelC_2", type_2: "number", label_2: "已嚼 ", text_2: "", suffix2: "年", helperText_2: "", max_2: 100
    }
    , betelD: {
      systemLabel: "已經戒食，戒了＿年＿個月。",
      label: "已經戒食，戒了", name: "betelD", type: "chkBoxTxT", checked: false, gridWid: 12
      , name_1: "betelD_1", type_1: "number", label_1: " ", text_1: "", suffix1: "年", helperText_1: "", max_1: 100
      , name_2: "betelD_2", type_2: "number", label_2: " ", text_2: "", suffix2: "個月", helperText_2: "", max_2: 12 //label需有空格
    }
  });

  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_2).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        betel: { ...prevState.betel, checked: total >= 1 ? true : false } //只更新這個
      }))
      if (total >= 1 && !array5thCheck.betel.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_2]); //避免循環

  const handleChangeChk5_2 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_2);
      keys.map(item => {
        delete array5_2[item].checked
      }
      )
      //set
      setArray5_2({
        ...array5_2,
        [name]: {
          ...array5_2[name], checked: checked
        }
      })
      setArray5thCheck(prevState => ({
        ...prevState,
        betelC_1: { ...prevState.betelC_1, value: "", error: false },
        betelC_2: { ...prevState.betelC_2, value: "", error: false },
        betelD_1: { ...prevState.betelD_1, value: "", error: false },
        betelD_2: { ...prevState.betelD_2, value: "", error: false },
      }));
    }
  }

  // const handleChangeTxt5_2 = e => {
  //   if (_.isNil(imageURL)) {  //已提交不得修改
  //     const { name, value } = e.target;
  //     setArray5_2({
  //       ...array5_2,
  //       [name]: { ...array5_2[name], text_1: value }
  //     });
  //   }
  // }



  const [array5_3, setArray5_3] = React.useState({
    drunkA: { name: "drunkA", label: "從未喝酒", type: "chkBox", checked: false, gridWid: 2, systemLabel: "從未喝酒　" }
    , drunkB: { name: "drunkB", label: "偶爾喝(不是天天)", type: "chkBox", checked: false, gridWid: 2, systemLabel: "偶爾喝(不是天天)　" }
    , drunkC: {
      systemLabel: "（幾乎）每天喝，平均每週喝＿次，最常喝＿酒，每次＿瓶",
      label: "（幾乎）每天喝", name: "drunkC", type: "chkBoxTxT", checked: false, gridWid: 8
      , name_1: "drunkC_1", type_1: "number", label_1: "平均每週喝", suffix1: "次", max_1: 28
      , name_2: "drunkC_2", type_2: "text", label_2: "最常喝 ", suffix2: "酒"
      , name_3: "drunkC_3", type_3: "number", label_3: "每次 ", suffix3: "瓶", max_3: 100
    }
    , drunkD: {
      systemLabel: "已經戒酒，戒了＿年＿個月。",
      label: "已經戒酒，戒了", name: "drunkD", type: "chkBoxTxT", checked: false, gridWid: 12
      , name_1: "drunkD_1", type_1: "number", label_1: " ", suffix1: "年", max_1: 100
      , name_2: "drunkD_2", type_2: "number", label_2: " ", suffix2: "個月", max_2: 12//label需有空格
    }
  });
  React.useEffect(() => {
    if (!initialRender.current) {
      const total = Object.values(array5_3).reduce((a, b) => a + (b.checked ? 1 : 0), 0)
      setArray5thCheck(prevState => ({
        ...prevState,
        drunk: { ...prevState.drunk, checked: total >= 1 ? true : false } //只更新這個
      }));
      //ProgressBar
      if (total >= 1 && !array5thCheck.drunk.checked) {
        setNumerator(prev => prev + 1)
      } else if (total === 0) {
        setNumerator(prev => prev - 1)
      }
    }
  }, [array5_3]); //避免循環

  const handleChangeChk5_3 = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      //先移除所有checked
      const keys = Object.keys(array5_3);
      keys.map(item => {
        // console.log(item)
        delete array5_3[item].checked
      })
      //set
      setArray5_3(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], checked: checked }
      }))
      setArray5thCheck(prevState => ({
        ...prevState,
        drunkC_1: { ...prevState.drunkC_1, value: "", error: false },
        drunkC_2: { ...prevState.drunkC_2, value: "", error: false },
        drunkC_3: { ...prevState.drunkC_3, value: "", error: false },
        drunkD_1: { ...prevState.drunkD_1, value: "", error: false },
        drunkD_2: { ...prevState.drunkD_2, value: "", error: false },
      }));

    }
  }

  const [gender, setGender] = React.useState({
    male: false,
    female: false,
    helperText: "請至少選取一個。"
  })
  const handleChangeChkGender = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, checked } = e.target;
      if (name === "male") {
        setGender({
          ...gender,
          female: !checked,
          male: checked
        })
      } else {
        setGender({
          ...gender,
          female: checked,
          male: !checked
        })
      }
    }
  }
  const formRef = React.createRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validator()) {
      //清除
      dispatch(actions.TAB_EDIT({ editing: true, key: 66 }))
      Update66th();

      // handleNext("",66);
    }
  }

  const validator = () => {
    const form = formRef.current; //參數1
    if (form.checkValidity()) {
      console.log("全部通過")
      //若驗證通過，刪除錯誤提示
      for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i];
        if (element.name === "gender") {
          setGender(omit(gender, ["error"]));
        }
        if (Object.keys(personal).includes(element.name)) {
          setPersonal(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }));
        }
        if (Object.keys(workExp).includes(element.name)) {
          setWorkExp(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }))
        }
        if (element.name === "checked3rd") {
          setCheck3rd(prevState => (omit(prevState, ["error"])))
        }
        if (element.name === "pastHistory") {
          set4thValidator(prevState => ({
            ...prevState,
            pastHistory: (omit(prevState.pastHistory, ["error"]))
          }))
        }
        if (Object.keys(array4th).includes(element.name)) {
          setArray4th(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }))
        }
        if (Object.keys(array5thCheck).includes(element.name)) {
          setArray5thCheck(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }));
        }
        if (element.name === "conscious") {
          set4thValidator(prevState => ({
            ...prevState,
            conscious: (omit(prevState.conscious, ["error"]))
          }))
        }
        if (Object.keys(array6th).includes(element.name)) {
          setArray6th(prevState => ({
            ...prevState,
            [element.name]: omit(prevState[element.name], ["error"])
          }))
        }
      }
      return true;
    } else {
      // const form = formRef.current;
      // console.log("還沒通過")
      alert("尚有問題未完成")
      for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i];
        if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
          // console.log(element.validationMessage, element.name);
          // console.log(element.value)
          // console.log(element.value, element.validationMessage, element.name, element.tagName)
          if (element.name === "gender") {
            setGender({ ...gender, error: true, helperText: element.validationMessage })
          }
          if (Object.keys(personal).includes(element.name)) {
            // console.log(element.name);
            setPersonal(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
          }
          if (Object.keys(workExp).includes(element.name)) {
            setWorkExp(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
          }
          if (element.name === "checked3rd") {
            setCheck3rd(prevState => ({
              ...prevState,
              error: true, helperText: element.validationMessage
            }));
          }
          if (element.name === "pastHistory") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
          }
          if (Object.keys(array4th).includes(element.name)) {
            setArray4th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
          }
          if (Object.keys(array5thCheck).includes(element.name)) {
            setArray5thCheck(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
            // console.log(array5thCheck);
          }
          if (element.name === "conscious") {
            set4thValidator(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }));
          }
          if (Object.keys(array6th).includes(element.name)) {
            setArray6th(prevState => ({
              ...prevState,
              [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
            }))
          }

        } else {//驗證通過，自訂訊息
          //有在settingObj的
          // console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)

          if (element.name === "gender") {
            setGender(omit(gender, ["error"]));
          }
          if (Object.keys(personal).includes(element.name)) {
            setPersonal(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (Object.keys(workExp).includes(element.name)) {
            setWorkExp(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (element.name === "checked3rd") {
            setCheck3rd(prevState => (omit(prevState, ["error"])))
          }
          if (element.name === "pastHistory") {
            set4thValidator(prevState => ({
              ...prevState,
              pastHistory: (omit(prevState.pastHistory, ["error"]))
            }))
          }
          if (Object.keys(array4th).includes(element.name)) {
            setArray4th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }
          if (Object.keys(array5thCheck).includes(element.name)) {
            setArray5thCheck(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }));
          }
          if (element.name === "conscious") {
            set4thValidator(prevState => ({
              ...prevState,
              conscious: (omit(prevState.conscious, ["error"]))
            }))
          }
          if (Object.keys(array6th).includes(element.name)) {
            setArray6th(prevState => ({
              ...prevState,
              [element.name]: omit(prevState[element.name], ["error"])
            }))
          }

        }
      }
      return false;
    }
  }
  const [personal, setPersonal] = React.useState({
    personalName: { name: "personalName", value: "" },
    personalID: { name: "personalID", value: "" },
    birthDate: { name: "birthDate", label: "4.出生日期", required: true, value: null, maxDate: new Date() },
    hireDate: { name: "hireDate", label: "5.受僱日期", required: true, value: null },
    examinationDate: { name: "examinationDate", label: "6. 體檢日期", required: true, value: null, minDate: new Date() }
  })
  const handleDateChange = (name, e, v) => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      setPersonal(prevState => ({
        ...prevState,
        [name]: {
          ...prevState[name],
          value: v
        }
      }));
    }
  }
  const handleChangeTxt1st = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      const { name, value } = e.target;
      setPersonal(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: value }
      }))
    }
  }

  const [workExp, setWorkExp] = React.useState({
    usedJob: { name: "usedJob", label: "1.曾經從事", type: "text", value: null, required: true },
    usedStart: { name: "usedStart", label: " ", type: "date", value: null, required: true, disableFuture: true },
    usedEnd: { name: "usedEnd", label: " ", type: "date", value: null, required: true, disableFuture: true },
    usedPeriod_Y: { name: "usedPeriod_Y", label: " ", value: null, min: 0, type: "number", endAdmt: "年", startAdmt: "共" },
    usedPeriod_M: { name: "usedPeriod_M", label: " ", value: null, min: 0, max: 12, type: "number", endAdmt: "個月" },
    rightNowJob: { name: "rightNowJob", label: "2.目前從事", type: "text", value: null, required: true },
    rightNowStart: { name: "rightNowStart", label: " ", type: "date", value: null, required: true, disableFuture: true },
    rightNowEnd: { name: "rightNowEnd", label: " ", type: "date", value: null, required: true, disableFuture: true },
    rightNowPeriod_Y: { name: "rightNowPeriod_Y", label: " ", value: null, min: 0, type: "number", endAdmt: "年", startAdmt: "共" },
    rightNowPeriod_M: { name: "rightNowPeriod_M", label: " ", value: null, min: 0, max: 12, type: "number", endAdmt: "個月" },
    workhours_1: { name: "workhours_1", type: "number", value: null, min: 0, step: 0.5, max: 168, endAdmt: "小時", required: true },
    workhours_2: { name: "workhours_2", type: "number", value: null, min: 0, step: 0.5, max: 168, endAdmt: "小時", required: true },
  })

  const handleChangeTxt2nd = e => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      // console.log("?!")
      const { name, value } = e.target;
      if (name === "usedJob" || name === "rightNowJob" || name === "workhours_1" || name === "workhours_2") {
        setWorkExp(prevState => ({
          ...prevState,
          [name]: { ...prevState[name], value: value }
        }))
        // console.log(workExp[name].value)

        if ((workExp[name].value === "" || workExp[name].value === null) && value !== "" && workExp[name].required === true) {
          setNumerator(prev => prev + 1)
        } else if (value === "" && workExp[name].required === true) {
          setNumerator(prev => prev - 1)
        }
      }
    }

  }
  const handleDateChange2nd = (name, e, v) => {
    if (_.isNil(imageURL)) {  //已提交不得修改
      console.log(name, v)
      console.log(workExp[name].value)
      setWorkExp(prevState => ({
        ...prevState,
        [name]: { ...prevState[name], value: v }
      }));
      if ((workExp[name].value === "" || workExp[name].value === null) && (v === "" || v === null)) {
        return
      }
      if ((workExp[name].value === "" || workExp[name].value === null) && (v !== null || v !== "") && workExp[name].required === true) {
        setNumerator(prev => prev + 1)
      } else if ((v === "" || v === null) && workExp[name].required === true) {
        setNumerator(prev => prev - 1)
      }
    }
  }
  const calculateWorkRange = () => {
    // console.log(workExp.usedStart.value)
    // console.log(workExp.usedEnd.value)
    if (!_.isNil(workExp.usedStart.value) && !_.isNil(workExp.usedEnd.value)) {
      let start = moment(workExp.usedStart.value + '01日', 'YYYY年MM月DD日')
      let end = moment(workExp.usedEnd.value + '01日', 'YYYY年MM月DD日')
      let months = moment.duration(end.diff(start)).asMonths();//總月份數
      let RoundMonths = Math.round(months)
      // console.log(RoundMonths)
      let y = Math.floor(RoundMonths / 12)
      let m = Math.round(RoundMonths % 12)
      // console.log(y, m)
      setWorkExp(prevState => ({
        ...prevState,
        usedPeriod_Y: { ...prevState.usedPeriod_Y, value: y },
        usedPeriod_M: { ...prevState.usedPeriod_M, value: m }
      }))
    }
    if (!_.isNil(workExp.rightNowStart.value) && !_.isNil(workExp.rightNowEnd.value)) {
      let start = moment(workExp.rightNowStart.value + '01日', 'YYYY年MM月DD日')
      let end = moment(workExp.rightNowEnd.value + '01日', 'YYYY年MM月DD日')
      let months = moment.duration(end.diff(start)).asMonths();//總月份數
      let RoundMonths = Math.round(months)
      // console.log(RoundMonths)

      let y = Math.floor(RoundMonths / 12)
      let m = Math.round(RoundMonths % 12)
      // console.log(y, m)
      setWorkExp(prevState => ({
        ...prevState,
        rightNowPeriod_Y: { ...prevState.rightNowPeriod_Y, value: y },
        rightNowPeriod_M: { ...prevState.rightNowPeriod_M, value: m }
      }))
    }
  }

  React.useEffect(() => {
    calculateWorkRange();
  }, [workExp.usedStart, workExp.usedEnd, workExp.rightNowEnd, workExp.rightNowStart]); //避免循環
  const useStyles = makeStyles({
    submitButton: {
      width: "100%", background: '#2E3B55', fontWeight: "bold",
      "&:hover": {
        background: '#fffff',
        // color:'#2E3B55'
      }
    },
    media: {
      height: 620,
      width: "100%",
      objectFit: 'cover',

    },

  });

  const classes = useStyles();
  React.useEffect(() => {
    if (initialRender.current) { //初始載入
      initialRender.current = false
    }
  }, []); //避免循環
  return (
    <Paper>
      <GridContainer>
        <GridItem className="App" ref={ref} id={'jsx-template'} xs={12} sm={12} md={10} lg={10}>
          <h1 style={{ textAlign: "center" }}>勞工體(健)檢問卷</h1>
          <form onSubmit={handleSubmit} ref={formRef} noValidate>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              {/* <fieldset>
                <legend align="left" style={{ fontWeight: "bold" }}>一、基本資料：</legend>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={3} lg={3}>
                    <TextField key={0} error={personal.personalName.error || false} required id="standard-required" name={personal.personalName.name} key={personal.personalName.name} label="1. 姓名" fullWidth
                      helperText={personal.personalName.error ? personal.personalName.helperText : null} autoComplete="off" inputProps={{ maxLength: 20 }} value={personal.personalName.value || ""} onChange={handleChangeTxt1st}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4} lg={4}>
                    <FormControl required error={gender.error || false} name="gender" >
                      <FormLabel>2.性別：</FormLabel>
                      <input type="checkbox" name={"gender"} required checked={gender.male || gender.female} style={{ opacity: 0, height: "0px" }} />
                      <FormGroup style={{ display: "inline" }}>
                        <FormControlLabel
                          control={<Checkbox checked={gender.male} onChange={handleChangeChkGender} name="male" color="primary" />}
                          label="男"
                        />
                        <FormControlLabel
                          control={<Checkbox checked={gender.female} onChange={handleChangeChkGender} name="female" color="secondary" />}
                          label="女"
                        />
                      </FormGroup>
                      {gender.error ? (<FormHelperText>{gender.helperText}</FormHelperText>) : null}
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <TextField key={1} error={personal.personalID.error || false} required id="standard-required" name={"personalID"} label="3. 身分證字號(居留證及護照號碼)"
                      helperText={personal.personalID.error ? personal.personalID.helperText : null} style={{ width: 300 }} inputProps={{ minLength: 9 }} autoComplete="off"
                      value={personal.personalID.value || ""} onChange={handleChangeTxt1st}
                    />
                  </GridItem>
                  {Object.values(personal).map((item, key) => {
                    if (key >= 2) { //前兩個無視
                      return (
                        <GridItem xs={12} sm={6} md={4} lg={4} >
                          <KeyboardDatePicker
                            format="YYYY年MM月DD日"
                            key={key}
                            views={["year", "month", "date"]}
                            fullWidth
                            autoOk
                            autoComplete="off"
                            clearable
                            type="datetime"
                            inputProps={{
                              // ...prop //像是minLength、pattern
                              pattern: "[0-9]{4}年(0[1-9]|1[012])月(0[1-9]|1[0-9]|2[0-9]|3[01])日"
                            }}
                            name={item.name}
                            required={item.required || false}
                            error={item.error || false}
                            helperText={
                              item.error ? (
                                item.helperText
                              ) : null}
                            todayLabel={<TodayIcon />}
                            showTodayButton
                            minDate={item.minDate || new Date("1900-01-01")}
                            maxDate={item.maxDate || new Date("2100-01-01")}
                            clearLabel={"X"}
                            label={item.label}
                            value={item.value}
                            inputValue={item.value}
                            onChange={(event, value) =>
                              handleDateChange(item.name, event, value)
                            }
                          />
                        </GridItem>
                      )
                    }
                  })
                  }
                </GridContainer>
              </fieldset> */}
              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}>一、作業經歷：</legend>
                <GridContainer>
                  {Object.values(workExp).slice(0, 1).map((item, key) => {
                    if (key === 0) {
                      return (
                        <ListItem button>
                          <FormGroup>
                            <FormControlLabel control={<TextField key={key} name={item.name} value={item.value || ""} style={{ width: 150 }} required={item.required} label=" " autoComplete="off" error={item.error || false} helperText={item.error ? item.helperText : null} onChange={handleChangeTxt2nd} />} labelPlacement={"start"} label={"1.曾經從事"} />
                          </FormGroup>
                        </ListItem>
                      )
                    } else if (key === 1 || key === 2) {
                      return (
                        <>
                          <label >{key === 1 ? "起始日期:" : "截止日期:"}</label>
                          <KeyboardDatePicker
                            format={(date) => moment(date).format("YYYY年MM月")}
                            key={key}
                            views={["year", "month"]}
                            autoOk
                            autoComplete="off"
                            clearable
                            type="datetime"
                            inputProps={{
                              // ...prop //像是minLength、pattern
                              pattern: "[0-9]{4}年(0[1-9]|1[012])月"
                            }}
                            style={{ width: 150 }}
                            name={item.name}
                            required={item.required || false}
                            disableFuture={item.disableFuture || false}
                            error={item.error || false}
                            helperText={
                              item.error ? (
                                item.helperText
                              ) : null}
                            todayLabel={<TodayIcon />}
                            showTodayButton
                            minDate={item.minDate || new Date("1900-01-01")}
                            maxDate={item.maxDate || new Date("2100-01-01")}
                            clearLabel={"X"}
                            label={item.label}
                            value={item.value}
                            inputValue={item.value}
                            onChange={(event, value) =>
                              handleDateChange2nd(item.name, event, value)
                            }
                          />
                        </>
                      )
                    } else {
                      return (
                        <TextField key={key} name={item.name} label=" " value={item.value} onChange={handleChangeTxt2nd} style={{ width: 120, textAlign: "center" }} error={item.error || false}
                          InputProps={{
                            endAdornment: <InputAdornment position="end">{item.endAdmt}</InputAdornment>,
                            startAdornment: <InputAdornment position="start">{item.startAdmt}</InputAdornment>,
                          }}
                          autoComplete="off"
                          helperText={item.error ? item.helperText : null}
                          inputProps={{ ...item, style: { textAlign: 'center' } }}
                        />
                      )

                    }

                  })}
                  {Object.values(workExp).slice(1, 5).map((item, key) => {
                    if (key === 0 || key === 1) {
                      return (
                        <FormControl>
                          <FormControlLabel
                            label={key === 0 ? "起始日期:" : "截止日期:"}
                            labelPlacement={"start"}
                            control={<KeyboardDatePicker
                              format="YYYY年MM月"
                              key={key}
                              views={["year", "month"]}
                              autoOk
                              autoComplete="off"
                              clearable
                              disableFuture={item.disableFuture || false}
                              type="datetime"
                              inputProps={{
                                // ...prop //像是minLength、pattern
                                pattern: "[0-9]{4}年(0[1-9]|1[012])月"
                              }}
                              style={{ width: 150 }}
                              name={item.name}
                              required={item.required || false}
                              error={item.error || false}
                              helperText={
                                item.error ? (
                                  item.helperText
                                ) : null}
                              todayLabel={<TodayIcon />}
                              showTodayButton
                              minDate={item.minDate || new Date("1900-01-01")}
                              maxDate={item.maxDate || new Date("2100-01-01")}
                              clearLabel={"X"}
                              label={item.label}
                              value={item.value}
                              inputValue={item.value}
                              onChange={(event, value) =>
                                handleDateChange2nd(item.name, event, value)
                              }
                            />
                            }
                          />
                        </FormControl>
                      )
                    } else {
                      return (
                        <FormControl>
                          <FormControlLabel
                            labelPlacement={"start"}
                            control={
                              <TextField key={key} name={item.name} label=" " value={item.value} onChange={handleChangeTxt2nd} style={{ width: 120, textAlign: "center" }} error={item.error || false}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{item.endAdmt}</InputAdornment>,
                                  startAdornment: <InputAdornment position="start">{item.startAdmt}</InputAdornment>,
                                }}
                                autoComplete="off"
                                helperText={item.error ? item.helperText : null}
                                inputProps={{ ...item, style: { textAlign: 'center' } }}
                              />
                            }
                          />
                        </FormControl>
                      )

                    }

                  })}

                  {Object.values(workExp).slice(5, 6).map((item, key) => {
                    if (key === 0) {
                      return (
                        <ListItem button>
                          <FormGroup>
                            <FormControlLabel control={<TextField key={key} name={item.name} value={item.value || ""} style={{ width: 150 }} required={item.required} label=" " autoComplete="off" error={item.error || false} helperText={item.error ? item.helperText : null} onChange={handleChangeTxt2nd} />}
                              labelPlacement={"start"}
                              label={"2.目前從事"} />
                          </FormGroup>
                        </ListItem>
                      )
                    } else if (key === 1 || key === 2) {
                      return (
                        <FormControl>
                          <FormControlLabel
                            label={key === 0 ? "起始日期:" : "截止日期:"}
                            labelPlacement={"start"}
                            control={<KeyboardDatePicker
                              format="YYYY年MM月"
                              key={key}
                              views={["year", "month"]}
                              autoOk
                              autoComplete="off"
                              clearable
                              disableFuture={item.disableFuture || false}
                              type="datetime"
                              inputProps={{
                                // ...prop //像是minLength、pattern
                                pattern: "[0-9]{4}年(0[1-9]|1[012])月"
                              }}
                              style={{ width: 150 }}
                              name={item.name}
                              required={item.required || false}
                              error={item.error || false}
                              helperText={
                                item.error ? (
                                  item.helperText
                                ) : null}
                              todayLabel={<TodayIcon />}
                              showTodayButton
                              minDate={item.minDate || new Date("1900-01-01")}
                              maxDate={item.maxDate || new Date("2100-01-01")}
                              clearLabel={"X"}
                              label={item.label}
                              value={item.value}
                              inputValue={item.value}
                              onChange={(event, value) =>
                                handleDateChange2nd(item.name, event, value)
                              }
                            />
                            }
                          />
                        </FormControl>
                      )
                    } else {
                      return (
                        <FormControl>
                          <FormControlLabel
                            labelPlacement={"start"}
                            control={
                              <TextField key={key} name={item.name} label=" " value={item.value} onChange={handleChangeTxt2nd} style={{ width: 120, textAlign: "center" }} error={item.error || false}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{item.endAdmt}</InputAdornment>,
                                  startAdornment: <InputAdornment position="start">{item.startAdmt}</InputAdornment>,
                                }}
                                autoComplete="off"
                                helperText={item.error ? item.helperText : null}
                                inputProps={{ ...item, style: { textAlign: 'center' } }}
                              />
                            }
                          />
                        </FormControl>
                      )
                    }
                  })}
                  {Object.values(workExp).slice(6, 10).map((item, key) => {
                    if (key === 0 || key === 1) {
                      return (
                        <FormControl>
                          <FormControlLabel
                            label={key === 0 ? "起始日期:" : "截止日期:"}
                            labelPlacement={"start"}
                            control={<KeyboardDatePicker
                              format="YYYY年MM月"
                              key={key}
                              views={["year", "month"]}
                              autoOk
                              autoComplete="off"
                              clearable
                              disableFuture={item.disableFuture || false}
                              type="datetime"
                              inputProps={{
                                // ...prop //像是minLength、pattern
                                pattern: "[0-9]{4}年(0[1-9]|1[012])月"
                              }}
                              style={{ width: 150 }}
                              name={item.name}
                              required={item.required || false}
                              error={item.error || false}
                              helperText={
                                item.error ? (
                                  item.helperText
                                ) : null}
                              todayLabel={<TodayIcon />}
                              showTodayButton
                              minDate={item.minDate || new Date("1900-01-01")}
                              maxDate={item.maxDate || new Date("2100-01-01")}
                              clearLabel={"X"}
                              label={item.label}
                              value={item.value}
                              inputValue={item.value}
                              onChange={(event, value) =>
                                handleDateChange2nd(item.name, event, value)
                              }
                            />
                            }
                          />
                        </FormControl>)
                    } else {
                      return (
                        <FormControl>
                          <FormControlLabel
                            labelPlacement={"start"}
                            control={
                              <TextField key={key} name={item.name} label=" " value={item.value} onChange={handleChangeTxt2nd} style={{ width: 120, textAlign: "center" }} error={item.error || false}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{item.endAdmt}</InputAdornment>,
                                  startAdornment: <InputAdornment position="start">{item.startAdmt}</InputAdornment>,
                                }}
                                autoComplete="off"
                                helperText={item.error ? item.helperText : null}
                                inputProps={{ ...item, style: { textAlign: 'center' } }}
                              />
                            }
                          />
                        </FormControl>
                      )
                    }
                  })}
                  {Object.values(workExp).slice(10, 11).map((item, key) => {
                    return (
                      <ListItem button>
                        <FormGroup>
                          <FormControlLabel control={
                            <TextField
                              required={item.required}
                              label=" "
                              error={item.error || false}
                              type={item.type}
                              style={{ width: 120 }}
                              name={item.name}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">小時</InputAdornment>,
                              }}
                              inputProps={{
                                ...item,
                                style: { textAlign: "center" }
                              }}
                              value={item.value || ""}
                              helperText={item.error ? item.helperText : null}
                              onChange={handleChangeTxt2nd}
                            />
                          } labelPlacement={"start"}
                            label={"3.過去 1 個月，平均每週工時為："} />
                        </FormGroup>
                      </ListItem>
                    )
                  })}
                  {Object.values(workExp).slice(11, 12).map((item, key) => {
                    return (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <TextField
                              required={item.required}
                              label=" "
                              error={item.error || false}
                              type={item.type}
                              style={{ width: 120 }}
                              name={item.name}
                              InputProps={{
                                endAdornment: <InputAdornment position="end">小時</InputAdornment>,
                              }}
                              inputProps={{
                                ...item,
                                style: { textAlign: "center" }
                              }}
                              value={item.value || ""}
                              helperText={item.error ? item.helperText : null}
                              onChange={handleChangeTxt2nd}
                            />
                          }
                          labelPlacement={"start"}
                          label={"；過去 6 個月，平均每週工時為："} />
                      </FormGroup>
                    )
                  })}
                </GridContainer>
              </fieldset>
              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}>二、檢查時期（原因）：</legend>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6} lg={6}>
                    <FormControl required error={checked3rd.error || false}>
                      <FormLabel> </FormLabel>
                      <input type="checkbox" name={"checked3rd"} required checked={checked3rd.checkA || checked3rd.checkB} style={{ opacity: 0, height: "0px" }} />
                      <FormGroup style={{ display: "inline" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checked3rd.checkA || false}
                              onChange={handleChangeThree}
                              name={"checkA"}
                              color="primary"
                            />
                          }
                          label={"新進員工"}
                          onMouseDown={() => { checked3rd.checkA ? playActive() : playOn(); }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checked3rd.checkB || false}
                              onChange={handleChangeThree}
                              name={"checkB"}
                              color="primary"
                            />
                          }
                          label={"定期檢查"}
                          onMouseDown={() => { checked3rd.checkB ? playActive() : playOn(); }}
                        />
                      </FormGroup>
                      {checked3rd.error ? (<FormHelperText>{checked3rd.helperText}</FormHelperText>) : null}
                    </FormControl>

                  </GridItem>

                </GridContainer>
              </fieldset>
              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}>三、既往病史：</legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup>
                      <FormControl required error={array4thValidator.pastHistory.error || false} style={{ width: "100%" }}>
                        <FormLabel>您是否曾患有下列慢性疾病：（請在適當項目前打勾）</FormLabel>
                        <input type="checkbox" name={array4thValidator.pastHistory.name} required checked={array4thValidator.pastHistory.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.pastHistory.error ? (<FormHelperText>{array4thValidator.pastHistory.helperText}</FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array4th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={6} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange4th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={item.label}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange4th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              error={item.error || false}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array4thTxtObj[item.name].text || ""}
                              label={item.label}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt4th}
                              // inputProps={{
                              //   type2:item.type
                              // }}
                              helperText={item.error ? item.helperText : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>
              <fieldset >
                <legend align="left" style={{ fontWeight: "bold" }}>四、生活習慣：</legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup>
                      <FormControl required error={array5thCheck.smoke.error || false} style={{ width: "100%" }}>
                        <FormLabel>1.請問您過去一個月內是否有吸菸？</FormLabel>
                        <input type="checkbox" name={array5thCheck.smoke.name} required checked={array5thCheck.smoke.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array5thCheck.smoke.error ? (<FormHelperText>{array5thCheck.smoke.helperText}</FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array5_1).map((item, key) => {
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid} style={{ display: "flex", alignItems: "center" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChangeChk5_1}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={item.label}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <div style={{ alignItems: "center", display: "inline-flex" }}>
                          <ListItem style={{ paddingRight: "0px" }}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={item.checked || false}
                                    onChange={handleChangeChk5_1}
                                    name={item.name}
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    color="primary"
                                  />
                                }
                                label={item.label}
                                onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <FormControlLabel
                                style={{ marginRight: "0px" }}
                                control={
                                  <TextField
                                    disabled={!item.checked || false}
                                    required={item.checked || false}
                                    error={array5thCheck[item.name_1].error || false}
                                    value={array5thCheck[item.name_1].value || ""}
                                    label={item.label_1}
                                    name={item.name_1}
                                    type={item.type_1}
                                    style={{ width: 120 }}
                                    autoComplete="off"
                                    onChange={handleChangeTxt5_1}
                                    helperText={array5thCheck[item.name_1].error ? array5thCheck[item.name_1].helperText : null}
                                    InputProps={{
                                      endAdornment: <InputAdornment position="end">{item.suffix1}</InputAdornment>,
                                    }}
                                    inputProps={{
                                      min: item.min_1,
                                      step: 1, style: { textAlign: 'center' },
                                      max: item.max_1 || null
                                    }}

                                  />}
                              />
                            </FormGroup>
                          </ListItem>
                          <FormGroup>
                            {item.label_2 ? (
                              <FormControlLabel
                                style={{ marginLeft: "0px" }}
                                labelPlacement={"start"}
                                label={"，"}
                                control={
                                  <TextField
                                    disabled={!item.checked || false}
                                    required={item.checked || false}
                                    error={array5thCheck[item.name_2].error || false}
                                    value={array5thCheck[item.name_2].value || ""}
                                    label={item.label_2}
                                    name={item.name_2}
                                    type={item.type_2}
                                    style={{ width: 120 }}
                                    autoComplete="off"
                                    onChange={handleChangeTxt5_1}
                                    helperText={array5thCheck[item.name_2].error ? array5thCheck[item.name_2].helperText : null}
                                    InputProps={{
                                      endAdornment: <InputAdornment position="end">{item.suffix2}</InputAdornment>,
                                    }}
                                    inputProps={{ min: 0, step: 1, style: { textAlign: 'center' }, max: item.max_2 || null }}
                                  />}
                              />

                            ) : null}
                          </FormGroup>
                        </div>
                      )
                    }
                  })}
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup>
                      <FormControl required error={array5thCheck.betel.error || false} style={{ width: "100%" }}>
                        <FormLabel>2.請問您最近六個月內是否有嚼食檳榔？</FormLabel>
                        <input type="checkbox" name={array5thCheck.betel.name} required checked={array5thCheck.betel.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array5thCheck.betel.error ? (<FormHelperText>{array5thCheck.betel.helperText}</FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array5_2).map((item, key) => {
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid} style={{ display: "flex", alignItems: "center" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChangeChk5_2}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={item.label}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <div style={{ alignItems: "center", display: "inline-flex" }}>
                          <ListItem style={{ paddingRight: "0px" }}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={item.checked || false}
                                    onChange={handleChangeChk5_2}
                                    name={item.name}
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    color="primary"
                                  />
                                }
                                label={item.label}
                                onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                              />
                            </FormGroup>
                            <FormGroup>
                              <FormControlLabel
                                style={{ marginRight: "0px" }}
                                control={
                                  <TextField
                                    disabled={!item.checked || false}
                                    required={item.checked || false}
                                    value={array5thCheck[item.name_1].value || ""}
                                    label={item.label_1}
                                    name={item.name_1}
                                    type={item.type_1}
                                    style={{ width: 120 }}
                                    autoComplete="off"
                                    onChange={handleChangeTxt5_1}
                                    error={array5thCheck[item.name_1].error || false}
                                    helperText={array5thCheck[item.name_1].error ? array5thCheck[item.name_1].helperText : null}
                                    InputProps={{
                                      endAdornment: <InputAdornment position="end">{item.suffix1}</InputAdornment>,
                                    }}
                                    inputProps={{
                                      min: 0,
                                      step: 1, style: { textAlign: 'center' },
                                      max: item.max_1 || null
                                    }}
                                  />}
                              />
                            </FormGroup>
                          </ListItem>
                          <FormGroup>
                            {item.label_2 ? (<FormControlLabel
                              style={{ marginLeft: "0px" }}
                              labelPlacement={"start"}
                              label={"，"}
                              control={<TextField
                                disabled={!item.checked || false}
                                required={item.checked || false}
                                value={array5thCheck[item.name_2].value || ""}
                                label={item.label_2}
                                name={item.name_2}
                                type={item.type_2}
                                style={{ width: 120 }}
                                autoComplete="off"
                                onChange={handleChangeTxt5_1}
                                error={array5thCheck[item.name_2].error || false}
                                helperText={array5thCheck[item.name_2].error ? array5thCheck[item.name_2].helperText : null}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{item.suffix2}</InputAdornment>,
                                }}
                                inputProps={{
                                  min: 0, step: 1, style: { textAlign: 'center' }, max: item.max_2 || null
                                }}
                              />}
                            />) : null}
                          </FormGroup>
                        </div>)
                    }
                  })}
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup>
                      <FormControl required error={array5thCheck.drunk.error || false} style={{ width: "100%" }}>
                        <FormLabel>3.請問您過去一個月內是否有喝酒？</FormLabel>
                        <input type="checkbox" name={array5thCheck.drunk.name} required checked={array5thCheck.drunk.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array5thCheck.drunk.error ? (<FormHelperText>{array5thCheck.drunk.helperText}</FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array5_3).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid} style={{ display: "flex", alignItems: "center" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChangeChk5_3}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={item.label}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <React.Fragment>
                          <div style={{ alignItems: "center", display: "inline-flex" }}>
                            <ListItem style={{ paddingRight: "0px" }}>
                              <FormGroup>
                                <FormControlLabel
                                  control={<Checkbox checked={item.checked || false} onChange={handleChangeChk5_3} name={item.name}
                                    inputProps={{ "aria-label": "primary checkbox" }}
                                    color="primary"
                                  />}
                                  label={item.label}
                                  onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                                />
                              </FormGroup>
                              <FormGroup>
                                <FormControlLabel
                                  style={{ marginRight: "0px" }}
                                  control={<TextField
                                    disabled={!item.checked || false}
                                    required={item.checked || false}
                                    value={array5thCheck[item.name_1].value || ""}
                                    label={item.label_1}
                                    name={item.name_1}
                                    type={item.type_1}
                                    style={{ width: 120 }}
                                    autoComplete="off"
                                    onChange={handleChangeTxt5_1}
                                    error={array5thCheck[item.name_1].error || false}
                                    helperText={array5thCheck[item.name_1].error ? array5thCheck[item.name_1].helperText : null}
                                    InputProps={{
                                      endAdornment: <InputAdornment position="end">{item.suffix1}</InputAdornment>,
                                    }}
                                    inputProps={{
                                      min: 0, style: { textAlign: 'center' }, max: item.max_1 || null
                                    }}
                                  />}
                                />
                              </FormGroup>
                            </ListItem>
                          </div>

                          <FormGroup style={{ alignItems: "center", display: "inline-flex" }}>
                            {item.label_2 ? (
                              <FormControlLabel
                                style={{ marginLeft: "0px" }}
                                labelPlacement={"start"}
                                label={"，"}
                                control={<TextField
                                  disabled={!item.checked || false}
                                  required={item.checked || false}
                                  value={array5thCheck[item.name_2].value || ""}
                                  label={item.label_2}
                                  name={item.name_2}
                                  type={item.type_2}
                                  style={{ width: 120 }}
                                  autoComplete="off"
                                  onChange={handleChangeTxt5_1}
                                  error={array5thCheck[item.name_2].error || false}
                                  helperText={array5thCheck[item.name_2].error ? array5thCheck[item.name_2].helperText : null}
                                  InputProps={{
                                    endAdornment: <InputAdornment position="end">{item.suffix2}</InputAdornment>,
                                  }}
                                  inputProps={{
                                    style: { textAlign: 'center' }
                                  }}
                                />}
                              />) : null}
                          </FormGroup>
                          <FormGroup>
                            {item.label_3 ? (<FormControlLabel
                              style={{ marginLeft: "0px" }}
                              labelPlacement={"start"}
                              label={"，"}
                              control={<TextField
                                disabled={!item.checked || false}
                                required={item.checked || false}
                                value={array5thCheck[item.name_3].value || ""}
                                label={item.label_3}
                                name={item.name_3}
                                type={item.type_3}
                                style={{ width: 120 }}
                                autoComplete="off"
                                onChange={handleChangeTxt5_1}
                                error={array5thCheck[item.name_3].error || false}
                                helperText={array5thCheck[item.name_3].error ? array5thCheck[item.name_3].helperText : null}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">{item.suffix3}</InputAdornment>,
                                }}
                                inputProps={{
                                  min: 0.1, step: 0.1, style: { textAlign: 'center' }, max: item.max_3 || null
                                }}
                              />}
                            />) : null}</FormGroup>

                        </React.Fragment>
                      )
                    }
                  })}
                </GridContainer>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label>4.請問您於工作日期間，平均每天睡眠時間為：</label>
                  <TextField
                    required
                    error={array5thCheck.sleep.error || false}
                    label=" "
                    type="number"
                    name={array5thCheck.sleep.name}
                    value={array5thCheck.sleep.value}
                    onChange={handleChangeTxt5_4}
                    inputProps={{ min: 0, step: 0.5, max: 24, style: { textAlign: "center" } }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">小時</InputAdornment>,
                    }}
                    helperText={array5thCheck.sleep.error ? array5thCheck.sleep.helperText : null}
                  />
                </div>
              </fieldset>
              <fieldset style={{ marginBottom: "50px" }} >
                <legend align="left" style={{ fontWeight: "bold" }}>五、自覺症狀：</legend>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <FormGroup>
                      <FormControl required error={array4thValidator.conscious.error || false} style={{ width: "100%" }}>
                        <FormLabel>您最近三個月是否常有下列症狀：（請在適當項目前打勾）</FormLabel>
                        <input type="checkbox" name={array4thValidator.conscious.name} required checked={array4thValidator.conscious.checked || false} style={{ opacity: 0, height: "0px" }} />
                        {array4thValidator.conscious.error ? (<FormHelperText>{array4thValidator.conscious.helperText}</FormHelperText>) : null}
                      </FormControl>
                    </FormGroup>
                  </GridItem>
                  {Object.values(array6th).map((item, key) => {
                    //console.log(item);
                    if (item.type === "chkBox") {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={item.checked || false}
                                onChange={handleChange6th}
                                name={item.name}
                                color="primary"
                              />
                            }
                            label={item.label}
                            onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                          />
                        </GridItem>)
                    } else {
                      return (
                        <GridItem xs={12} sm={item.gridWid} md={item.gridWid} lg={item.gridWid}>
                          <ListItem style={{ marginLeft: "-11px", paddingLeft: "0px" }}>
                            <Checkbox
                              checked={item.checked || false}
                              onChange={handleChange6th}
                              name={item.name}
                              key={key + 'chk'}
                              inputProps={{ "aria-label": "primary checkbox" }}
                              color="primary"
                              onMouseDown={() => { item.checked || false ? playActive() : playOn(); }}
                            />
                            <TextField
                              fullWidth
                              key={key + 'txt'}
                              disabled={!item.checked || false}
                              required={item.checked || false}
                              value={array4thTxtObj[item.name].text || ""}
                              label={item.label}
                              name={item.name}
                              autoComplete="off"
                              onChange={handleChangeTxt4th}
                              error={item.error || false}
                              helperText={item.error ? item.helperText : null}
                            />
                          </ListItem>
                        </GridItem>)
                    }

                  })}
                </GridContainer>
              </fieldset>
              <div style={{ width: '100%', bottom: !imageURL ? "36px" : "0px", position: "fixed", }}>
                <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} />
              </div>
              {/* <Signature setImage={setImage} imageURL={imageURL} setTime={setTime} handleSubmit={handleSubmit} open={open} setOpen={setOpen} Update66th={Update66th} /> */}
              {!imageURL ? (<div style={{ bottom: 0, position: "fixed", width: "100%" }}>
                <Button variant="contained" color="primary" type="submit" onClick={handleSubmit} className={classes.submitButton}>提 交</Button>
              </div>) : null}

            </MuiPickersUtilsProvider>
          </form>
          {/* {imageURL ?
            (<div id={"signature"} >
              <div style={{ textAlign: "lefts" }} >
                <img
                  src={imageURL}
                  alt="my signature"
                  align="center"
                  style={{
                    // display: "block",
                    margin: "0 auto",
                    borderBottom: "1px solid black",
                    width: "250px",
                    paddingLeft: "30px", //讓簽名更像
                    paddingRight: "30px",//讓簽名更像
                  }}
                />
              </div>
              <div>
                <label>簽名時間：{timestamp}</label>
              </div>
            </div>
            )
            : null
          } */}

        </GridItem>

      </GridContainer>
      {/* <div>
        {imageURL ? <Button variant="outlined" color="primary" onClick={ToPdf} style={{ margin: "0 40px" }}>上傳</Button> : null}
      </div> */}
    </Paper>
  );
}

export default App;
